<div class="bm-debt-collection-activity bg-white">
        <div class="activity-content">

            <div class="grid">
                <div class="col-12">
                    <div class="flex justify-content-between">
                        <div>
                            <h3 class="text-xl">INKA Übergabe berechnen</h3>
                        </div>
                        <div class="flex gap-2">
                            <p-button label="Validation"></p-button>
                            <p-button label="Process" [disabled]="true"></p-button>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="flex justify-content-end align-items-center gap-2">
                        <label for="ingredient1">Kunden schriftlich in Kenntnis setzten</label>
                        <p-toggleswitch id="ingredient1"/>
                    </div>
                </div>

                <p-divider />

                <!--     TOTAL VIEW       -->

                <div class="col-12 lg:col-6">
                    <div class="billing-account-block">
                        <div class="contract-card">
                            <div class="contract-header text-base font-bold">
                                <div>Abrechnungskonto</div>
                            </div>

                            <!-- Rows -->
                            <div class="contract-rows">

                                <!-- CONTRACT PRICE -->
                                <div class="contract-row" *ngFor="let charge of dunningData?.charges">
                                    <div class="row-label">{{ charge.name }}</div>

                                    <div class="row-right">
                                        <div class="w-4 flex justify-content-end">
                                            <p-button
                                                [label]="'Edit'"
                                                size="small"
                                                [rounded]="true"
                                                [text]="true"
                                                [disabled]="!charge.deductable && !charge.reducable"
                                                (click)="openChargeAdjustmentDialog(charge)"
                                            />
<!--                                            <i *ngIf="isChargeAdjusted(charge)"-->
<!--                                               class="pi pi-refresh inactive-arrow tone-info cursor"-->
<!--                                               pTooltip="Restore"-->
<!--                                               (click)="restoreCharge(charge)"></i>-->
                                        </div>
                                        <div class="row-amount">
                                            {{ charge.amount | number: '1.2-2' }} €
                                        </div>
                                        <i
                                            class="fa-regular cursor"
                                            [ngClass]="{
                                                'text-primary fa-arrow-right-long-to-line': !isChargeActive(charge),
                                                'text-red-500 fa-arrow-left-long-to-line': isChargeActive(charge),
                                                'cursor-not-allowed opacity-50': !charge.deductable && isChargeActive(charge)
                                            }"
                                            (click)="toggleCharge(charge)"
                                            >
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p-divider />
                <!--            CONTRACTS VIEW          -->

                <div class="col-12">

                    <div>
                        <h4 class="text-base">Detailübersicht Verträge</h4>
                    </div>

                    <div class="contracts-grid">

                        <div *ngFor="let contract of dunningData?.contracts"
                                class="contract-card" [class.is-new]="contract.status === 'new'">
                                <!-- Header row -->
                                <div class="contract-header text-base font-bold">
                                    <div>{{ contract.type }}</div>

                                    <div class="contract-head-right">
                                        <div class="contract-id cursor" (click)="selectContract(contract)">
                                            <i class="fa-regular fa-file-invoice text-primary"></i>
                                            <span>{{ contract.identifier }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Rows -->
                                <div class="contract-rows">
                                    <div class="contract-row">
                                        <div class="row-label">Status</div>
                                        <div class="row-right"><p-tag severity="info" class="{{getContractStyleClass(contract)}}" value="{{ getContractBadge(contract) }}"/></div>
                                    </div>
                                    <!-- CONTRACT PRICE -->
                                    <div class="contract-row">
                                        <div class="row-label">{{ contract.partner }}</div>

                                        <div class="row-right">
                                            <div class="row-amount flex gap-2 justify-content-end">
                                                @if (contract?.monthlyPrice?.length > 1) {
                                                    <i
                                                            class="fa-regular fa-chart-mixed-up-circle-dollar cursor-pointer text-primary"
                                                            (click)="handleContractPriceView(pricePanel, $event, contract)"
                                                            aria-label="Show price history"
                                                    ></i>
                                                }

                                                <span class="row-amount">{{ contract.monthlyPrice[contract.monthlyPrice.length - 1]?.monthlyPrice | number:'1.2-2' }}
                                                    €</span>
                                            </div>
                                        </div>
                                    </div>


                                    <!-- Bis WIK -->
                                    <div class="contract-row">
                                        <div class="row-label">Months</div>

                                        <div class="row-right">
                                            <div class="row-amount flex justify-content-center align-items-center gap-2">
                                                <span class="pi pi-minus text-red-500 bg-white p-1 rounded-circle shadow-2 text-xs cursor" (click)="updateContractDunningAmount(contract, 'dec')"></span>
                                                {{ contract.dunningMonths }}
                                                <span class="pi pi-plus text-primary bg-white p-1 rounded-circle shadow-2 text-xs cursor" (click)="updateContractDunningAmount(contract, 'inc')"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Rückstand -->
                                    <div class="contract-row">
                                        <div class="row-label">Rückstand</div>

                                        <div class="row-right">
                                            <div class="row-amount">
                                                {{ contract.dunningAmount | number:'1.2-2' }} €
                                            </div>
                                        </div>
                                    </div>

                                    <!-- WIK zum / Startdatum -->
                                    <div class="contract-row">
                                        <div class="row-label">
                                            {{ contract.status === 'new' ? 'Startdatum' : 'WIK zum' }}
                                        </div>

                                        <div class="row-right">
                                            <div
                                                    class="row-date"
                                                    [ngClass]="{ 'line-through text-color-secondary': contract.status === 'cancelled' }">
                                                {{ getWikDate(contract) }}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                        </div>

                    </div>

                </div>
            </div>


        </div>

</div>
<!-- Charge Adjustment Dialog -->
<p-dialog
        header="Adjust Charge"
        [(visible)]="showChargeAdjustmentDialog"
        [modal]="true"
        [closable]="false"
        [style]="{ width: '460px' }"
        contentStyleClass="p-0">

    <div *ngIf="selectedCharge" class="p-4 flex flex-column gap-4">

        <!-- Charge summary -->
        <div class="flex justify-content-between align-items-center p-3 surface-50 border-round">
            <div class="flex flex-column gap-1">
                <span class="text-sm text-color-secondary">Charge</span>
                <span class="font-semibold">{{ selectedCharge.name }}</span>
            </div>

            <div class="text-right">
                <span class="text-sm text-color-secondary">Original Amount</span>
                <div class="font-semibold">
                    {{ selectedCharge.amount | number:'1.2-2' }} EUR
                </div>
            </div>
        </div>

        <!-- Adjustment type -->
        <div class="flex flex-column gap-2">
            <label class="font-medium text-sm">Adjustment Type</label>

            <div class="flex gap-2">
                <button
                        pButton
                        type="button"
                        label="Remove"
                        icon="pi pi-trash"
                        [disabled]="!selectedCharge.deductable"
                        class="flex-1"
                        [ngClass]="{ 'p-button-outlined': chargeAdjustmentType !== 'remove' }"
                        (click)="chargeAdjustmentType = 'remove'">
                </button>

                <button
                        pButton
                        type="button"
                        label="Reduce"
                        icon="pi pi-minus"
                        [disabled]="!selectedCharge.reducable"
                        class="flex-1"
                        [ngClass]="{ 'p-button-outlined': chargeAdjustmentType !== 'reduce' }"
                        (click)="chargeAdjustmentType = 'reduce'">
                </button>
            </div>
        </div>

        <!-- Reduced amount -->
        <div *ngIf="chargeAdjustmentType === 'reduce'"
             class="flex flex-column gap-2">

            <label class="font-medium text-sm">New Amount (EUR)</label>

            <p-inputNumber
                    [(ngModel)]="reducedChargeAmount"
                    [min]="0"
                    [max]="selectedCharge.amount"
                    mode="decimal"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    class="w-full">
            </p-inputNumber>

            <small class="text-color-secondary">
                Must be less than or equal to the original amount
            </small>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2 p-3 border-top-1 surface-border">
            <button
                    pButton
                    type="button"
                    label="Cancel"
                    class="p-button-text"
                    (click)="showChargeAdjustmentDialog = false">
            </button>

            <button
                    pButton
                    type="button"
                    label="Apply & Add"
                    icon="pi pi-check"
                    (click)="applyChargeAdjustment()">
            </button>
        </div>
    </ng-template>

</p-dialog>

<p-popover #pricePanel [dismissable]="true" styleClass="price-overlay">
    <ng-template pTemplate="content">
        <div class="flex flex-column gap-2 min-w-15rem">
            <div
                    *ngFor="let price of selectedContractForPriceView?.monthlyPrice"
                    class="flex gap-2 text-sm"
            >
                <span>{{ price.startMonth | date: 'MMM yyyy' }}</span>
                <strong>{{ price.monthlyPrice | number:'1.2-2' }} €</strong>
            </div>
        </div>
    </ng-template>
</p-popover>
